export default __webpack_public_path__ + "static/media/p1 copy 3.b26ca9cb.png";